module.exports = __webpack_public_path__ + "static/wikiviewer.1366c449.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wikiviewer.png
// module id = 471
// module chunks = 246384609461072